export const AuthFormDisplayStates = [
  'default',
  'watchlist',
  'carAlerts',
  'checkout',
  'personalisedQuote',
  'carmatch',
] as const;

export type AuthFormDisplayState = (typeof AuthFormDisplayStates)[number];

export enum AuthFormErrors {
  ACCOUNT_NOT_VALIDATED = 21,
  PASSWORD_INVALID = 31,
  PENDING_VERIFICATION = 41,
}
